import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { RegionalizacaoCodigoEnum } from "../../enum/lenguage";
import { useCountryStore } from "../../stores/useCountry";
import { useLoadStore } from "../../stores/useLoad";
import styles from "./styles.module.scss";

export const Float = () => {
  const { country } = useCountryStore();
  const setCountry = useCountryStore((state) => state.setCountry);
  const { setLoading } = useLoadStore();

  const regionalizacaoOpcoes = [
    {
      assets: `https://flagcdn.com/w40/${RegionalizacaoCodigoEnum.Brasil.toLowerCase()}.png`,
      codigo: RegionalizacaoCodigoEnum.Brasil,
      nome: "Brasil",
    },
    {
      assets: `https://flagcdn.com/w40/${RegionalizacaoCodigoEnum.Colombia.toLowerCase()}.png`,
      codigo: RegionalizacaoCodigoEnum.Colombia,
      nome: "Colombia",
    },
    {
      assets: `https://flagcdn.com/w40/${RegionalizacaoCodigoEnum.Peru.toLowerCase()}.png`,
      codigo: RegionalizacaoCodigoEnum.Peru,
      nome: "Peru",
    },
    {
      assets: `https://flagcdn.com/w40/${RegionalizacaoCodigoEnum.Equador.toLowerCase()}.png`,
      codigo: RegionalizacaoCodigoEnum.Equador,
      nome: "Equador",
    },
  ];

  const handleChange = (event: SelectChangeEvent<RegionalizacaoCodigoEnum>) => {
    const selectedCountry = event.target.value as RegionalizacaoCodigoEnum;
    setLoading(true);
    setCountry(selectedCountry);
  };

  const mediaMobile = useMediaQuery("(min-width:750px)");

  return (
    <Box
      className={`${styles.container} ${
        mediaMobile ? styles.containerDesktop : styles.containerMobile
      }`}
    >
      <FormControl fullWidth>
        <Select
          value={country as RegionalizacaoCodigoEnum | undefined}
          onChange={handleChange}
          displayEmpty
          className={styles.select}
          MenuProps={{
            PaperProps: {
              className: styles.menuItem,
            },
          }}
        >
          {regionalizacaoOpcoes.map((option) => (
            <MenuItem
              key={option.codigo}
              value={option.codigo}
              className={styles.menuItem}
            >
              <Box className={styles.optionBox}>
                <img
                  src={option.assets}
                  alt={option.nome}
                  style={{ width: 24, height: 16, marginRight: 8 }}
                />
                <Typography className={styles.optionText}>
                  {option.nome}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
